export const URL_PARAMS = {
  thread: 'channel_thread_id',
  message: 'channel_message_id',
};
